import { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router';

import { ToggleButtonGroup } from '@/components/shared/toggle-button-group';
import { useWizard } from '@/context/wizard';
import { StepTitle } from '@/packages/subsidy/pages/refund-request/steps/resource-description/components/step-title';
import {
  RefundQueryParams,
  type RefundRequestWizardProps,
} from '@/packages/subsidy/pages/refund-request/steps/resource-description/interfaces';
import { useRefundRequestNavigation } from '@/packages/subsidy/pages/refund-request/steps/resource-description/navigation/use-navigation';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';
import { ResourceApprovalItem } from './components/resource-approval-item';

const initialCount = 3;
const loadMoreCount = 6;

export const ResourceType = () => {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(initialCount);
  const {
    values: { resourceApprovals },
  } = useWizard<RefundRequestWizardProps>();

  const visibleApprovals = resourceApprovals?.slice(0, visibleCount);
  const hasMore = resourceApprovals && visibleCount < resourceApprovals.length;

  const { handleNext } = useRefundRequestNavigation({
    stepId: RefundRequestWizardStepIds.ResourceType,
  });
  const handleResourceApproval = (resourceUuid: string) =>
    navigate(
      `/meus-reembolsos/solicitacao/${resourceUuid}?step=${RefundQueryParams.Invoice}`
    );

  return (
    <Stack gap={2}>
      <StepTitle>Itens já aprovados:</StepTitle>
      <ToggleButtonGroup onChange={handleResourceApproval}>
        {visibleApprovals?.map((approval) => (
          <ResourceApprovalItem
            key={approval.uuid}
            resourceApproval={approval}
          />
        ))}
      </ToggleButtonGroup>

      <Stack direction="row" gap={2}>
        {hasMore && (
          <Button
            onClick={() => setVisibleCount((prev) => prev + loadMoreCount)}
          >
            Ver mais itens aprovados ({resourceApprovals.length - visibleCount})
          </Button>
        )}
        <Button onClick={() => handleNext()}>
          Pedir reembolso para outro item
        </Button>
      </Stack>
    </Stack>
  );
};
